"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4458],{

/***/ 54221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sA": function() { return /* binding */ harvestFarm; },
  "qq": function() { return /* binding */ nonBscStakeFarm; },
  "zv": function() { return /* binding */ nonBscUnstakeFarm; },
  "AQ": function() { return /* binding */ stakeFarm; },
  "dU": function() { return /* binding */ unstakeFarm; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(6391);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(7599);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/utils/bigNumber.ts
var bigNumber = __webpack_require__(81834);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 28 modules
var contractHelpers = __webpack_require__(30896);
;// CONCATENATED MODULE: ./src/views/Farms/hooks/getNonBscVaultFee.ts






var MessageTypes;
(function(MessageTypes) {
    MessageTypes[MessageTypes["Deposit"] = 0] = "Deposit";
    MessageTypes[MessageTypes["Withdraw"] = 1] = "Withdraw";
    MessageTypes[MessageTypes["EmergencyWithdraw"] = 2] = "EmergencyWithdraw";
    MessageTypes[MessageTypes["Claim"] = 3] = "Claim";
})(MessageTypes || (MessageTypes = {}));
var Chains;
(function(Chains) {
    Chains[Chains["EVM"] = 0] = "EVM";
    Chains[Chains["BSC"] = 1] = "BSC";
})(Chains || (Chains = {}));
var COMPENSATION_PRECISION = 1e5;
var ORACLE_PRECISION = 1e18;
var BNB_CHANGE = 5000000000000000;
var BUFFER = 1.3;
var WITHDRAW_BUFFER = 1.4;
var getNonBscVaultContractFee = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var pid, amount, chainId, userAddress, messageType, oraclePrice, gasPrice, nonBscVaultContract, crossFarmingAddress, exchangeRate, getNonce, nonce, ref, encodeMessage, hasFirstTime, estimateGaslimit, calcFee, msgBusFee, destTxFee, totalFee, depositFee, estimateEvmGaslimit, fee, total, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pid = param.pid, amount = param.amount, chainId = param.chainId, userAddress = param.userAddress, messageType = param.messageType, oraclePrice = param.oraclePrice, gasPrice = param.gasPrice;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    nonBscVaultContract = (0,contractHelpers/* getNonBscVaultContract */.aM)(null, chainId);
                    crossFarmingAddress = (0,contractHelpers/* getCrossFarmingSenderContract */.bd)(null, chainId);
                    exchangeRate = new (bignumber_default())(ORACLE_PRECISION).div(oraclePrice).times(ORACLE_PRECISION) // invert into BNB/ETH price
                    ;
                    return [
                        4,
                        crossFarmingAddress.nonces(userAddress, pid)
                    ];
                case 2:
                    getNonce = _state.sent();
                    nonce = new (bignumber_default())(getNonce.toString()).toJSON();
                    return [
                        4,
                        Promise.all([
                            nonBscVaultContract.encodeMessage(userAddress, pid, amount, messageType, nonce),
                            crossFarmingAddress.is1st(userAddress),
                            crossFarmingAddress.estimateGaslimit(Chains.BSC, userAddress, messageType)
                        ])
                    ];
                case 3:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), encodeMessage = ref[0], hasFirstTime = ref[1], estimateGaslimit = ref[2];
                    return [
                        4,
                        nonBscVaultContract.calcFee(encodeMessage)
                    ];
                case 4:
                    calcFee = _state.sent();
                    msgBusFee = new (bignumber_default())(calcFee.toString());
                    destTxFee = new (bignumber_default())(gasPrice).times(estimateGaslimit.toString()).times(exchangeRate).times(COMPENSATION_PRECISION).div(new (bignumber_default())(ORACLE_PRECISION).times(COMPENSATION_PRECISION));
                    totalFee = new (bignumber_default())(msgBusFee).plus(destTxFee);
                    if (!hasFirstTime) {
                        depositFee = new (bignumber_default())(BNB_CHANGE).times(exchangeRate).div(ORACLE_PRECISION);
                        return [
                            2,
                            totalFee.plus(depositFee).times(BUFFER).toFixed(0)
                        ];
                    }
                    if (!(messageType >= MessageTypes.Withdraw)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        crossFarmingAddress.estimateGaslimit(Chains.EVM, userAddress, messageType)
                    ];
                case 5:
                    estimateEvmGaslimit = _state.sent();
                    fee = msgBusFee.times(exchangeRate).div(ORACLE_PRECISION);
                    total = new (bignumber_default())(gasPrice).times(estimateEvmGaslimit.toString()).plus(fee);
                    return [
                        2,
                        totalFee.plus(total).times(WITHDRAW_BUFFER).toFixed(0)
                    ];
                case 6:
                    return [
                        2,
                        totalFee.times(BUFFER).toFixed(0)
                    ];
                case 7:
                    error = _state.sent();
                    console.error("Failed to fetch non BscVault fee", error);
                    return [
                        2,
                        bigNumber/* BIG_ZERO.toJSON */.HW.toJSON()
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function getNonBscVaultContractFee(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/calls/farms.ts





var stakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(masterChefContract, pid, amount, gasPrice, gasLimit) {
        var value;
        return (0,tslib_es6.__generator)(this, function(_state) {
            value = new (bignumber_default())(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
            return [
                2,
                masterChefContract.deposit(pid, value, {
                    gasLimit: gasLimit || config/* DEFAULT_GAS_LIMIT */.QL,
                    gasPrice: gasPrice
                })
            ];
        });
    });
    return function stakeFarm(masterChefContract, pid, amount, gasPrice, gasLimit) {
        return _ref.apply(this, arguments);
    };
}();
var unstakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(masterChefContract, pid, amount, gasPrice, gasLimit) {
        var value;
        return (0,tslib_es6.__generator)(this, function(_state) {
            value = new (bignumber_default())(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
            return [
                2,
                masterChefContract.withdraw(pid, value, {
                    gasLimit: gasLimit || config/* DEFAULT_GAS_LIMIT */.QL,
                    gasPrice: gasPrice
                })
            ];
        });
    });
    return function unstakeFarm(masterChefContract, pid, amount, gasPrice, gasLimit) {
        return _ref.apply(this, arguments);
    };
}();
var harvestFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(masterChefContract, pid, gasPrice, gasLimit) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            console.log("Harvesting ".concat(pid, ", ").concat(masterChefContract), gasLimit);
            return [
                2,
                masterChefContract.deposit(pid, "0", {
                    gasLimit: gasLimit || config/* DEFAULT_GAS_LIMIT */.QL,
                    gasPrice: gasPrice
                })
            ];
        });
    });
    return function harvestFarm(masterChefContract, pid, gasPrice, gasLimit) {
        return _ref.apply(this, arguments);
    };
}();
var nonBscStakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contract, pid, amount, gasPrice, account, oraclePrice, chainId) {
        var value, totalFee;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    value = new (bignumber_default())(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
                    return [
                        4,
                        getNonBscVaultContractFee({
                            pid: pid,
                            chainId: chainId,
                            gasPrice: gasPrice,
                            oraclePrice: oraclePrice,
                            amount: value,
                            userAddress: account,
                            messageType: MessageTypes.Deposit
                        })
                    ];
                case 1:
                    totalFee = _state.sent();
                    console.info(totalFee, "stake totalFee");
                    return [
                        2,
                        contract.deposit(pid, value, {
                            value: totalFee
                        })
                    ];
            }
        });
    });
    return function nonBscStakeFarm(contract, pid, amount, gasPrice, account, oraclePrice, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var nonBscUnstakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contract, pid, amount, gasPrice, account, oraclePrice, chainId) {
        var value, totalFee;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    value = new (bignumber_default())(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
                    return [
                        4,
                        getNonBscVaultContractFee({
                            pid: pid,
                            chainId: chainId,
                            gasPrice: gasPrice,
                            oraclePrice: oraclePrice,
                            amount: value,
                            userAddress: account,
                            messageType: MessageTypes.Withdraw
                        })
                    ];
                case 1:
                    totalFee = _state.sent();
                    console.info(totalFee, "unstake totalFee");
                    return [
                        2,
                        contract.withdraw(pid, value, {
                            value: totalFee
                        })
                    ];
            }
        });
    });
    return function nonBscUnstakeFarm(contract, pid, amount, gasPrice, account, oraclePrice, chainId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 72179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zj": function() { return /* reexport */ callWithEstimateGas; },
  "yp": function() { return /* reexport */ getActivePools; },
  "sA": function() { return /* reexport */ farms/* harvestFarm */.sA; },
  "qq": function() { return /* reexport */ farms/* nonBscStakeFarm */.qq; },
  "zv": function() { return /* reexport */ farms/* nonBscUnstakeFarm */.zv; },
  "AQ": function() { return /* reexport */ farms/* stakeFarm */.AQ; },
  "dU": function() { return /* reexport */ farms/* unstakeFarm */.dU; }
});

// UNUSED EXPORTS: estimateGas

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(5305);
;// CONCATENATED MODULE: ./src/utils/calls/estimateGas.ts





/**
 * Estimate the gas needed to call a function, and add a 10% margin
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param gasMarginPer10000 The gasMargin per 10000 (i.e. 10% -> 1000)
 * @param args An array of arguments to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var estimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _estimateGas, rawGasEstimation, gasEstimation;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, gasMarginPer10000 = _arguments.length > 4 ? _arguments[4] : void 0;
                    if (!contract[methodName]) {
                        throw new Error("Method ".concat(methodName, " doesn't exist on ").concat(contract.address));
                    }
                    return [
                        4,
                        (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                            overrides
                        ]))
                    ];
                case 1:
                    rawGasEstimation = _state.sent();
                    gasEstimation = (0,utils/* calculateGasMargin */.yC)(rawGasEstimation, gasMarginPer10000);
                    return [
                        2,
                        gasEstimation
                    ];
            }
        });
    });
    return function estimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Perform a contract call with a gas value returned from estimateGas
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param methodArgs An array of arguments to pass to the method
 * @param overrides An overrides object to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var callWithEstimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _contract, gasEstimation, tx;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, gasMarginPer10000 = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 1000;
                    return [
                        4,
                        estimateGas(contract, methodName, methodArgs, overrides, gasMarginPer10000)
                    ];
                case 1:
                    gasEstimation = _state.sent();
                    return [
                        4,
                        (_contract = contract)[methodName].apply(_contract, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                            (0,_object_spread/* default */.Z)({
                                gasLimit: gasEstimation
                            }, overrides)
                        ]))
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        2,
                        tx
                    ];
            }
        });
    });
    return function callWithEstimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/calls/farms.ts + 1 modules
var farms = __webpack_require__(54221);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(6391);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(73486);
// EXTERNAL MODULE: ./src/config/abi/sousChefV2.json
var sousChefV2 = __webpack_require__(9022);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(25152);
// EXTERNAL MODULE: ./src/utils/providers.ts
var providers = __webpack_require__(11536);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(70627);
;// CONCATENATED MODULE: ./src/utils/calls/pools.ts
/* eslint-disable import/prefer-default-export */ 









/**
 * Returns the total number of pools that were active at a given block
 */ var getActivePools = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(block) {
        var eligiblePools, blockNumber, _tmp, startBlockCalls, endBlockCalls, ref, startBlocks, endBlocks;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    eligiblePools = pools/* default.filter */.ZP.filter(function(pool) {
                        return pool.sousId !== 0;
                    }).filter(function(pool) {
                        return pool.isFinished === false || pool.isFinished === undefined;
                    });
                    _tmp = block;
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        providers/* bscRpcProvider.getBlockNumber */.v.getBlockNumber()
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    blockNumber = _tmp;
                    startBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "startBlock"
                        };
                    });
                    endBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "bonusEndBlock"
                        };
                    });
                    return [
                        4,
                        Promise.all([
                            (0,multicall/* default */.Z)(sousChefV2, startBlockCalls),
                            (0,multicall/* default */.Z)(sousChefV2, endBlockCalls)
                        ])
                    ];
                case 3:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), startBlocks = ref[0], endBlocks = ref[1];
                    return [
                        2,
                        eligiblePools.reduce(function(accum, poolCheck, index) {
                            var startBlock = startBlocks[index] ? new (bignumber_default())(startBlocks[index]) : null;
                            var endBlock = endBlocks[index] ? new (bignumber_default())(endBlocks[index]) : null;
                            if (!startBlock || !endBlock) {
                                return accum;
                            }
                            if (startBlock.gte(blockNumber) || endBlock.lte(blockNumber)) {
                                return accum;
                            }
                            return (0,_to_consumable_array/* default */.Z)(accum).concat([
                                poolCheck
                            ]);
                        }, [])
                    ];
            }
        });
    });
    return function getActivePools(block) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/calls/index.ts





/***/ }),

/***/ 3763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90902);
// Constructing the two forward-slash-separated parts of the 'Add Liquidity' URL
// Each part of the url represents a different side of the LP pair.

var getLiquidityUrlPathParts = function(param) {
    var quoteTokenAddress = param.quoteTokenAddress, tokenAddress = param.tokenAddress, chainId = param.chainId;
    var wNativeAddress = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .WNATIVE */ .FX[chainId];
    var firstPart = !quoteTokenAddress || quoteTokenAddress === (wNativeAddress === null || wNativeAddress === void 0 ? void 0 : wNativeAddress.address) ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .NATIVE */ .B5[chainId].symbol : quoteTokenAddress;
    var secondPart = !tokenAddress || tokenAddress === (wNativeAddress === null || wNativeAddress === void 0 ? void 0 : wNativeAddress.address) ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .NATIVE */ .B5[chainId].symbol : tokenAddress;
    return "".concat(firstPart, "/").concat(secondPart, "?chainId=").concat(chainId);
};
/* harmony default export */ __webpack_exports__["Z"] = (getLiquidityUrlPathParts);


/***/ }),

/***/ 59709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tn": function() { return /* binding */ BCakeBoosterCard; },
/* harmony export */   "k2": function() { return /* binding */ useBCakeTooltipContent; }
/* harmony export */ });
/* unused harmony exports CardWrapper, ImageWrapper */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95134);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67252);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13670);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62392);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(98813);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65342);
/* harmony import */ var components_ConnectWalletButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39480);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65957);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3411);
/* harmony import */ var _hooks_useBCakeProxyContractAddress__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62704);
/* harmony import */ var _hooks_useUserBoosterStatus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92516);
/* harmony import */ var _hooks_useUserLockedCakeStatus__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82159);
/* harmony import */ var _YieldBooster_components_CreateProxyButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41732);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  margin-top: 10px;\n  ",
        " {\n    width: 296px;\n    margin-left: 50px;\n  }\n  ",
        " {\n    margin-top: 0px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: -50px;\n  transform: translateY(-50%) scale(75%);\n  right: 10px;\n  ",
        " {\n    right: auto;\n    top: 60px;\n    left: 10px;\n    transform: translateY(-50%);\n  }\n  z-index: 2;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: none;\n  position: relative;\n  padding: 8px 24px 16px;\n  &::before {\n    content: '';\n    position: absolute;\n    height: 1px;\n    width: calc(100% - 48px);\n    top: 0px;\n    left: 24px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var CardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8fd09722-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8fd09722-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledCardBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8fd09722-2"
})(_templateObject2());
var StyledCardFooter = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8fd09722-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var useBCakeTooltipContent = function() {
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var tooltipContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            mb: "20px",
            children: t("Yield Boosters allow you to boost your farming yields by locking OSCAR in the fixed-term staking OSCAR pool. The more OSCAR you lock, and the longer you lock them, the higher the boost you will receive.")
        })
    });
    return tooltipContent;
};
var BCakeBoosterCard = function() {
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* .useTheme */ .Fg)();
    var isMobile = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)().isMobile;
    var tooltipContent = useBCakeTooltipContent();
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(tooltipContent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
        placement: "bottom-start"
    }, isMobile && {
        hideTimeout: 1500
    })), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/images/v05.png",
                alt: "boosterCardImage",
                width: 200,
                height: 191
            })
        })
    });
};
var CardContent = function() {
    var t = useTranslation().t;
    var ref = useActiveWeb3React(), account = ref.account, chainId = ref.chainId;
    var ref1 = useBCakeProxyContractAddress(account, chainId), proxyCreated = ref1.proxyCreated, refreshProxyAddress = ref1.refreshProxyAddress;
    var ref2 = useUserBoosterStatus(account), maxBoostCounts = ref2.maxBoostCounts, remainingCounts = ref2.remainingCounts;
    var ref3 = useUserLockedCakeStatus(), locked = ref3.locked, lockedEnd = ref3.lockedEnd;
    var theme = useTheme();
    if (!account) return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                bold: true,
                children: t("Connect wallet to view booster")
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                mb: "16px",
                children: t("An active fixed-term OSCAR staking position is required for activating farm yield boosters.")
            }),
            /*#__PURE__*/ _jsx(ConnectWalletButton, {
                width: "100%",
                style: {
                    backgroundColor: theme.colors.textSubtle
                }
            })
        ]
    });
    if (!locked) return /*#__PURE__*/ _jsxs(Box, {
        width: "100%",
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                bold: true,
                children: t("No CAKE locked")
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                mb: "16px",
                children: t("An active fixed-term OSCAR staking position is required for activating farm yield boosters.")
            }),
            /*#__PURE__*/ _jsx(NextLink, {
                href: "/pools",
                passHref: true,
                children: /*#__PURE__*/ _jsx(Button, {
                    as: "a",
                    width: "100%",
                    style: {
                        backgroundColor: theme.colors.textSubtle
                    },
                    children: t("Go to Pool")
                })
            })
        ]
    });
    if (lockedEnd === "0" || new Date() > new Date(parseInt(lockedEnd) * 1000)) return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                bold: true,
                children: t("Locked staking is ended")
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                mb: "16px",
                children: t("An active fixed-term OSCAR staking position is required for activating farm yield boosters.")
            }),
            /*#__PURE__*/ _jsx(NextLink, {
                href: "/pools",
                passHref: true,
                children: /*#__PURE__*/ _jsx(Button, {
                    as: "a",
                    width: "100%",
                    style: {
                        backgroundColor: theme.colors.textSubtle
                    },
                    children: t("Go to Pool")
                })
            })
        ]
    });
    if (!proxyCreated) {
        return /*#__PURE__*/ _jsxs(Box, {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    color: "textSubtle",
                    fontSize: 12,
                    bold: true,
                    children: t("Available Yield Booster")
                }),
                /*#__PURE__*/ _jsx(Text, {
                    color: "textSubtle",
                    fontSize: 12,
                    mb: "16px",
                    children: t("A one-time setup is required for enabling farm yield boosters.")
                }),
                /*#__PURE__*/ _jsx(CreateProxyButton, {
                    onDone: refreshProxyAddress,
                    style: {
                        backgroundColor: theme.colors.textSubtle
                    }
                })
            ]
        });
    }
    if (remainingCounts > 0) return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                justifyContent: "space-between",
                alignItems: "center",
                mb: "5px",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        color: "secondary",
                        fontSize: 12,
                        bold: true,
                        textTransform: "uppercase",
                        children: t("Available Yield Booster")
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        color: "secondary",
                        fontSize: 16,
                        bold: true,
                        textTransform: "uppercase",
                        children: [
                            remainingCounts,
                            "/",
                            maxBoostCounts
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                children: t("You will be able to activate the yield booster on an additional %num% farm(s).", {
                    num: remainingCounts
                })
            })
        ]
    });
    return /*#__PURE__*/ _jsxs(Box, {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        color: "secondary",
                        fontSize: 12,
                        bold: true,
                        textTransform: "uppercase",
                        children: t("Available Yield Booster")
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        color: "secondary",
                        fontSize: 12,
                        bold: true,
                        textTransform: "uppercase",
                        children: "0"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Text, {
                color: "textSubtle",
                fontSize: 12,
                children: t("To activate yield boosters on additional farms, unset yield boosters on some currently boosted farms.")
            })
        ]
    });
};


/***/ }),

/***/ 74637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65342);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65957);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11298);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87652);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98813);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89495);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8046);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(83931);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7642);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_toNumber__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var views_Farms_components_YieldBooster_components_BCakeCalculator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40933);
/* harmony import */ var state_farms_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8919);
/* harmony import */ var _YieldBooster_components_ProxyFarmContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65563);
/* harmony import */ var _YieldBooster_hooks_useBoostMultiplier__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16406);
/* harmony import */ var _YieldBooster_hooks_useGetBoostedAPR__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83117);












var ApyButton = function(param) {
    var variant = param.variant, pid = param.pid, lpLabel = param.lpLabel, lpTokenPrice = param.lpTokenPrice, lpSymbol = param.lpSymbol, cakePrice = param.cakePrice, apr = param.apr, multiplier = param.multiplier, displayApr = param.displayApr, lpRewardsApr = param.lpRewardsApr, addLiquidityUrl = param.addLiquidityUrl, strikethrough = param.strikethrough, useTooltipText = param.useTooltipText, hideButton = param.hideButton, boosted = param.boosted;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var account = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().account;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        return null;
    }), bCakeMultiplier = ref[0], setBCakeMultiplier = ref[1];
    var ref1 = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useFarmUser */ .Dx)(pid), tokenBalance = ref1.tokenBalance, stakedBalance = ref1.stakedBalance, proxy = ref1.proxy;
    var lpTotalSupply = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useFarmFromPid */ .f6)(pid).lpTotalSupply;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_YieldBooster_components_ProxyFarmContainer__WEBPACK_IMPORTED_MODULE_7__/* .YieldBoosterStateContext */ ._), boosterState = ref2.boosterState, proxyAddress = ref2.proxyAddress;
    var userBalanceInFarm = stakedBalance.plus(tokenBalance).gt(0) ? stakedBalance.plus(tokenBalance) : proxy.stakedBalance.plus(proxy.tokenBalance);
    var boosterMultiplierFromFE = (0,_YieldBooster_hooks_useGetBoostedAPR__WEBPACK_IMPORTED_MODULE_9__/* .useGetBoostedMultiplier */ .ax)(userBalanceInFarm, lpTotalSupply);
    var boostMultiplierFromSC = (0,_YieldBooster_hooks_useBoostMultiplier__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        pid: pid,
        boosterState: boosterState,
        proxyAddress: proxyAddress
    });
    var boostMultiplier = userBalanceInFarm.eq(0) ? boostMultiplierFromSC : boosterMultiplierFromFE;
    var boostMultiplierDisplay = boostMultiplier.toLocaleString(undefined, {
        maximumFractionDigits: 3
    });
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        account: account,
        pid: pid,
        linkLabel: t("Get %symbol%", {
            symbol: lpLabel
        }),
        stakingTokenBalance: userBalanceInFarm,
        stakingTokenDecimals: 18,
        stakingTokenSymbol: lpSymbol,
        stakingTokenPrice: lpTokenPrice.toNumber(),
        earningTokenPrice: cakePrice.toNumber(),
        apr: bCakeMultiplier ? apr * bCakeMultiplier : apr,
        multiplier: multiplier,
        displayApr: bCakeMultiplier ? (lodash_toNumber__WEBPACK_IMPORTED_MODULE_4___default()(displayApr) - apr + apr * bCakeMultiplier).toFixed(2) : displayApr,
        linkHref: addLiquidityUrl,
        isFarm: true,
        bCakeCalculatorSlot: function(calculatorBalance) {
            return boosted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(views_Farms_components_YieldBooster_components_BCakeCalculator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                targetInputBalance: calculatorBalance,
                earningTokenPrice: cakePrice.toNumber(),
                lpTotalSupply: lpTotalSupply,
                setBCakeMultiplier: setBCakeMultiplier
            }) : null;
        }
    }), false, true, "FarmModal".concat(pid)), 1), onPresentApyModal = ref3[0];
    var handleClickButton = function(event) {
        event.stopPropagation();
    // onPresentApyModal()
    };
    var ref4 = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                children: [
                    t("APR (incl. LP rewards)"),
                    ":",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        style: {
                            display: "inline-block"
                        },
                        color: strikethrough && "secondary",
                        children: strikethrough ? "".concat((apr * boostMultiplier + lpRewardsApr).toFixed(2), "%") : "".concat(displayApr, "%")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                ml: "5px",
                children: [
                    "*",
                    t("Base APR (OSCAR yield only)"),
                    ":",
                    " ",
                    strikethrough ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        style: {
                            display: "inline-block"
                        },
                        color: "secondary",
                        children: "".concat((apr * boostMultiplier).toFixed(2), "%")
                    }) : "".concat(apr.toFixed(2), "%")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                ml: "5px",
                children: [
                    "*",
                    t("LP Rewards APR"),
                    ": ",
                    lpRewardsApr === 0 ? "-" : lpRewardsApr,
                    "%"
                ]
            }),
            strikethrough && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                children: [
                    t("Available Boosted"),
                    ":",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        color: "secondary",
                        style: {
                            display: "inline-block"
                        },
                        children: t("Up to %boostMultiplier%x", {
                            boostMultiplier: boostMultiplierDisplay
                        })
                    })
                ]
            }),
            strikethrough && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                color: "secondary",
                children: t("Boost only applies to base APR (OSCAR yield)")
            })
        ]
    }), {
        placement: "top"
    }), targetRef = ref4.targetRef, tooltip = ref4.tooltip, tooltipVisible = ref4.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* .Farm.FarmApyButton */ .l.FarmApyButton, {
        variant: variant,
        hideButton: hideButton,
        strikethrough: strikethrough,
        handleClickButton: handleClickButton,
        children: useTooltipText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    ref: targetRef,
                    decorationColor: "secondary",
                    children: [
                        displayApr,
                        "%"
                    ]
                }),
                tooltipVisible && tooltip
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                displayApr,
                "%"
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ApyButton);


/***/ }),

/***/ 76694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3411);
/* harmony import */ var views_Farms_components_FarmCard_ApyButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74637);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7599);
/* harmony import */ var utils_getLiquidityUrlPathParts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3763);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74009);
/* harmony import */ var hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76166);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n\n  button {\n    width: 20px;\n    height: 20px;\n\n    svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 60px;\n  text-align: left;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var Container = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bccfd90-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var AprWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9bccfd90-1"
})(_templateObject1());
var Apr = function(param) {
    var value = param.value, pid = param.pid, lpLabel = param.lpLabel, lpSymbol = param.lpSymbol, lpTokenPrice = param.lpTokenPrice, multiplier = param.multiplier, tokenAddress = param.tokenAddress, quoteTokenAddress = param.quoteTokenAddress, cakePrice = param.cakePrice, originalValue = param.originalValue, _hideButton = param.hideButton, hideButton = _hideButton === void 0 ? false : _hideButton, strikethrough = param.strikethrough, lpRewardsApr = param.lpRewardsApr, _useTooltipText = param.useTooltipText, useTooltipText = _useTooltipText === void 0 ? true : _useTooltipText, boosted = param.boosted;
    var chainId = (0,hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_5__/* .useActiveChainId */ .g)().chainId;
    var liquidityUrlPathParts = (0,utils_getLiquidityUrlPathParts__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        quoteTokenAddress: quoteTokenAddress,
        tokenAddress: tokenAddress,
        chainId: chainId
    });
    var addLiquidityUrl = "".concat(config__WEBPACK_IMPORTED_MODULE_3__/* .BASE_ADD_LIQUIDITY_URL */ .wI, "/").concat(liquidityUrlPathParts);
    return originalValue !== 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        children: originalValue ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(views_Farms_components_FarmCard_ApyButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            variant: hideButton ? "text" : "text-and-button",
            pid: pid,
            lpSymbol: lpSymbol,
            lpLabel: lpLabel,
            lpTokenPrice: lpTokenPrice,
            multiplier: multiplier,
            cakePrice: cakePrice,
            apr: originalValue,
            displayApr: value,
            lpRewardsApr: lpRewardsApr,
            addLiquidityUrl: addLiquidityUrl,
            strikethrough: strikethrough,
            useTooltipText: useTooltipText,
            hideButton: hideButton,
            boosted: boosted
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AprWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                width: 60
            })
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AprWrapper, {
            children: [
                originalValue,
                "%"
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Apr);


/***/ }),

/***/ 40933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BCakeCalculator; },
  "K": function() { return /* binding */ getBCakeMultiplier; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/localization/src/index.tsx + 6 modules
var src = __webpack_require__(65957);
// EXTERNAL MODULE: ../../packages/uikit/src/components/RoiCalculatorModal/useRoiCalculatorReducer.ts
var useRoiCalculatorReducer = __webpack_require__(44368);
// EXTERNAL MODULE: ../../packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(98813);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(89495);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(46098);
// EXTERNAL MODULE: ../../packages/uikit/src/components/BalanceInput/BalanceInput.tsx
var BalanceInput = __webpack_require__(50420);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(76903);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(48608);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(13670);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(78933);
// EXTERNAL MODULE: ../../node_modules/wagmi/dist/wagmi.esm.js + 25 modules
var wagmi_esm = __webpack_require__(51523);
// EXTERNAL MODULE: ../../node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(6391);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ../../node_modules/lodash/toNumber.js
var toNumber = __webpack_require__(7642);
var toNumber_default = /*#__PURE__*/__webpack_require__.n(toNumber);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(7599);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3411);
// EXTERNAL MODULE: ../../packages/utils/formatBalance.ts
var formatBalance = __webpack_require__(18426);
// EXTERNAL MODULE: ./src/views/Farms/components/BCakeBoosterCard.tsx
var BCakeBoosterCard = __webpack_require__(59709);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useUserLockedCakeStatus.ts
var useUserLockedCakeStatus = __webpack_require__(82159);
// EXTERNAL MODULE: ./src/views/Pools/components/utils/formatSecondsToWeeks.ts
var formatSecondsToWeeks = __webpack_require__(14457);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/hooks/useGetBoostedAPR.ts
var useGetBoostedAPR = __webpack_require__(83117);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(13023);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(76660);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(73486);
;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/BCakeLockedDuration.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n  box-sizing: border-box;\n  padding-right: 55px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var DURATIONS = [
    1,
    5,
    10,
    25,
    52
];
var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-5fbc963e-0"
})(_templateObject());
var LockDurationField = function(param) {
    var duration = param.duration, setDuration = param.setDuration, isOverMax = param.isOverMax, currentDuration = param.currentDuration, currentDurationLeft = param.currentDurationLeft;
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var maxAvailableDuration = currentDurationLeft ? pools/* MAX_LOCK_DURATION */.VO - currentDurationLeft : pools/* MAX_LOCK_DURATION */.VO;
    // When user extends the duration due to time passed when approving
    // transaction the extended duration will be a couple of seconds off to max duration,
    // therefore it is better to compare based on weeks
    var currentDurationInWeeks = (0,react.useMemo)(function() {
        return currentDuration && (0,formatSecondsToWeeks/* secondsToWeeks */.Ot)(currentDuration);
    }, [
        currentDuration
    ]);
    var maxDurationInWeeks = (0,react.useMemo)(function() {
        return (0,formatSecondsToWeeks/* secondsToWeeks */.Ot)(pools/* MAX_LOCK_DURATION */.VO);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mb: "16px",
                mt: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        mb: "8px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "12px",
                            color: "textSubtle",
                            bold: true,
                            textTransform: "uppercase",
                            children: t("locked for")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        children: DURATIONS.map(function(week) {
                            var weekSeconds = (0,formatSecondsToWeeks/* weeksToSeconds */.AS)(week);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                onClick: function() {
                                    setDuration(weekSeconds);
                                },
                                pl: "12px",
                                pr: "12px",
                                scale: "sm",
                                disabled: weekSeconds > maxAvailableDuration,
                                variant: weekSeconds === duration ? "subtle" : "light",
                                children: [
                                    week,
                                    "W"
                                ]
                            }, week);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "center",
                alignItems: "center",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        mr: "8px",
                        width: "50%",
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                                value: (0,formatSecondsToWeeks/* secondsToWeeks */.Ot)(duration),
                                autoComplete: "off",
                                pattern: "^[0-9]+$",
                                inputMode: "numeric",
                                scale: "sm",
                                onChange: function(e) {
                                    var ref;
                                    var weeks = toNumber_default()(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                    if (e.currentTarget.validity.valid && weeks < 53) {
                                        var ref1;
                                        setDuration((0,formatSecondsToWeeks/* weeksToSeconds */.AS)(toNumber_default()(e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value)));
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                position: "absolute",
                                width: "60px",
                                top: "8px",
                                right: "0px",
                                color: theme.colors.text,
                                style: {
                                    textAlign: "center"
                                },
                                children: t("Weeks")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: function() {
                            setDuration(currentDuration);
                        },
                        scale: "sm",
                        disabled: currentDuration === 0,
                        variant: "tertiary",
                        width: "50%",
                        children: t("My Duration")
                    }, "max")
                ]
            }),
            isOverMax && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "12px",
                textAlign: "right",
                color: "failure",
                children: t("Total lock duration exceeds 52 weeks")
            }),
            currentDurationLeft && currentDurationInWeeks === maxDurationInWeeks ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                    maxWidth: "240px",
                    children: t('Recommend choosing "MAX" to renew your staking position in order to keep similar yield boost.')
                })
            }) : null
        ]
    });
};
/* harmony default export */ var BCakeLockedDuration = (LockDurationField);

;// CONCATENATED MODULE: ./src/views/Farms/components/YieldBooster/components/BCakeCalculator.tsx

function BCakeCalculator_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100%;\n  padding: 16px;\n  box-sizing: border-box;\n  border-radius: 16px;\n"
    ]);
    BCakeCalculator_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var BCakeBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c3670dd-0"
})(BCakeCalculator_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var BCakeCalculator = function(param) {
    var targetInputBalance = param.targetInputBalance, earningTokenPrice = param.earningTokenPrice, initialState = param.initialState, _stakingTokenSymbol = param.stakingTokenSymbol, stakingTokenSymbol = _stakingTokenSymbol === void 0 ? "AETH" : _stakingTokenSymbol, lpTotalSupply = param.lpTotalSupply, setBCakeMultiplier = param.setBCakeMultiplier;
    var ref = (0,react.useState)(true), isShow = ref[0], setIsShow = ref[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var ref1 = (0,react.useState)(function() {
        return (0,formatSecondsToWeeks/* weeksToSeconds */.AS)(1);
    }), duration = ref1[0], setDuration = ref1[1];
    var ref2 = (0,useUserLockedCakeStatus/* useUserLockedCakeStatus */.u)(), isLoading = ref2.isLoading, lockedAmount = ref2.lockedAmount, lockedStart = ref2.lockedStart, lockedEnd = ref2.lockedEnd;
    var ref3 = (0,useRoiCalculatorReducer/* default */.ZP)({
        stakingTokenPrice: earningTokenPrice,
        earningTokenPrice: earningTokenPrice,
        autoCompoundFrequency: 0
    }, initialState), state = ref3.state, setPrincipalFromUSDValue = ref3.setPrincipalFromUSDValue, setPrincipalFromTokenValue = ref3.setPrincipalFromTokenValue, toggleEditingCurrency = ref3.toggleEditingCurrency, setCalculatorMode = ref3.setCalculatorMode;
    var editingCurrency = state.controls.editingCurrency;
    var _data = state.data, principalAsUSD = _data.principalAsUSD, principalAsToken = _data.principalAsToken;
    var onBalanceFocus = function() {
        setCalculatorMode(useRoiCalculatorReducer/* CalculatorMode.ROI_BASED_ON_PRINCIPAL */.ee.ROI_BASED_ON_PRINCIPAL);
    };
    var userBalanceInFarm = (0,react.useMemo)(function() {
        return new (bignumber_default())(targetInputBalance).multipliedBy(config/* DEFAULT_TOKEN_DECIMAL */.o3);
    }, [
        targetInputBalance
    ]);
    var userLockedAmount = (0,react.useMemo)(function() {
        return new (bignumber_default())(principalAsToken).multipliedBy(config/* DEFAULT_TOKEN_DECIMAL */.o3);
    }, [
        principalAsToken
    ]);
    var bCakeMultiplier = (0,useGetBoostedAPR/* useGetCalculatorMultiplier */.yK)(userBalanceInFarm, lpTotalSupply, userLockedAmount, duration);
    (0,react.useEffect)(function() {
        setBCakeMultiplier(bCakeMultiplier);
    }, [
        bCakeMultiplier,
        setBCakeMultiplier
    ]);
    var editingUnit = editingCurrency === useRoiCalculatorReducer/* EditingCurrency.TOKEN */.We.TOKEN ? stakingTokenSymbol : "USD";
    var editingValue = editingCurrency === useRoiCalculatorReducer/* EditingCurrency.TOKEN */.We.TOKEN ? principalAsToken : principalAsUSD;
    var conversionUnit = editingCurrency === useRoiCalculatorReducer/* EditingCurrency.TOKEN */.We.TOKEN ? "USD" : stakingTokenSymbol;
    var conversionValue = editingCurrency === useRoiCalculatorReducer/* EditingCurrency.TOKEN */.We.TOKEN ? principalAsUSD : principalAsToken;
    var onUserInput = editingCurrency === useRoiCalculatorReducer/* EditingCurrency.TOKEN */.We.TOKEN ? setPrincipalFromTokenValue : setPrincipalFromUSDValue;
    var ref4 = (0,wagmi_esm/* useAccount */.mA)(), account = ref4.address;
    var tooltipContent = (0,BCakeBoosterCard/* useBCakeTooltipContent */.k2)();
    var ref5 = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref5.targetRef, tooltip = ref5.tooltip, tooltipVisible = ref5.tooltipVisible;
    var ref6 = (0,useTooltip/* default */.Z)(t("Boost multiplier calculation does not include profit from CAKE staking pool"), {
        placement: "bottom-start"
    }), myBalanceTargetRef = ref6.targetRef, myBalanceTooltip = ref6.tooltip, myBalanceTooltipVisible = ref6.tooltipVisible;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "secondary",
                bold: true,
                fontSize: "12px",
                textTransform: "uppercase",
                mt: "24px",
                mb: "8px",
                children: t("Yield Booster")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                scale: "md",
                checked: isShow,
                onClick: function() {
                    return setIsShow(!isShow);
                }
            }),
            isShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BCakeBlock, {
                        style: {
                            marginTop: 24
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                bold: true,
                                fontSize: "12px",
                                textTransform: "uppercase",
                                children: t("Cake locked")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceInput/* default */.Z, {
                                inputProps: {
                                    scale: "sm"
                                },
                                currencyValue: "".concat(conversionValue, " ").concat(conversionUnit),
                                // innerRef={balanceInputRef}
                                placeholder: "0.00",
                                value: editingValue,
                                unit: editingUnit,
                                onUserInput: onUserInput,
                                switchEditingUnits: toggleEditingCurrency,
                                onFocus: onBalanceFocus
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                mt: "8px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        scale: "xs",
                                        p: "4px 16px",
                                        width: "68px",
                                        variant: "tertiary",
                                        onClick: function() {
                                            return setPrincipalFromUSDValue("100");
                                        },
                                        children: "$100"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        scale: "xs",
                                        p: "4px 16px",
                                        width: "68px",
                                        variant: "tertiary",
                                        onClick: function() {
                                            return setPrincipalFromUSDValue("1000");
                                        },
                                        children: "$1000"
                                    }),
                                    myBalanceTooltipVisible && myBalanceTooltip,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        ref: myBalanceTargetRef,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            disabled: !account || isLoading || lockedAmount.eq(0),
                                            scale: "xs",
                                            p: "4px 16px",
                                            width: "128px",
                                            variant: "tertiary",
                                            style: {
                                                textTransform: "uppercase"
                                            },
                                            onClick: function() {
                                                return setPrincipalFromUSDValue((0,formatBalance/* getBalanceNumber */.mW)(lockedAmount.times(earningTokenPrice)).toFixed(2));
                                            },
                                            children: t("My Balance")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BCakeLockedDuration, {
                                duration: duration,
                                setDuration: setDuration,
                                currentDuration: toNumber_default()(lockedEnd) - toNumber_default()(lockedStart),
                                isOverMax: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BCakeBlock, {
                        style: {
                            marginTop: 16
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                bold: true,
                                fontSize: "12px",
                                textTransform: "uppercase",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: t("Boost Multiplier")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "text",
                                bold: true,
                                fontSize: "20px",
                                textTransform: "uppercase",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            bCakeMultiplier,
                                            "X"
                                        ]
                                    }),
                                    tooltipVisible && tooltip,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        ref: targetRef,
                                        marginLeft: "3px",
                                        display: "inline-block",
                                        position: "relative",
                                        top: "3px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                            color: theme.colors.textSubtle
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                fontSize: 12,
                                children: t("The estimated boost multiplier is calculated using live data. The actual boost multiplier may change upon activation.")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_BCakeCalculator = (BCakeCalculator);
var CA = 0.5;
var CB = 5;
var getBCakeMultiplier = function(userBalanceInFarm, userLockAmount, userLockDuration, totalLockAmount, lpBalanceOfFarm, averageLockDuration) {
    var dB = userBalanceInFarm.times(CA);
    var aBPart1 = lpBalanceOfFarm.times(userLockAmount).times(userLockDuration);
    var aBPart3 = totalLockAmount.times(averageLockDuration);
    var aB = aBPart1.dividedBy(CB).dividedBy(aBPart3);
    var bigNumberResult = dB.plus(aB).gt(userBalanceInFarm) ? userBalanceInFarm.dividedBy(dB) : dB.plus(aB).dividedBy(dB);
    return bigNumberResult;
};


/***/ }),

/***/ 41732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5163);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65957);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22723);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48608);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73685);
/* harmony import */ var components_Toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28715);
/* harmony import */ var hooks_useCatchTxError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78950);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68390);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);












var MAX_GAS_LIMIT = 2500000;
var CreateProxyButton = function(_param) {
    var onDone = _param.onDone, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "onDone"
    ]);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var farmBoosterProxyFactoryContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_4__/* .useBCakeFarmBoosterProxyFactoryContract */ .lZ)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isCreateProxyLoading = ref[0], setIsCreateProxyLoading = ref[1];
    var toastSuccess = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* .useToast */ .p)().toastSuccess;
    var ref1 = (0,hooks_useCatchTxError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), fetchWithCatchTxError = ref1.fetchWithCatchTxError, loading = ref1.loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        width: "100%"
    }, props), {
        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            var receipt, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setIsCreateProxyLoading(true);
                        return [
                            4,
                            fetchWithCatchTxError(function() {
                                return farmBoosterProxyFactoryContract.createFarmBoosterProxy({
                                    gasLimit: MAX_GAS_LIMIT
                                });
                            })
                        ];
                    case 1:
                        receipt = _state.sent();
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess(t("Contract Enabled"), /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Toast__WEBPACK_IMPORTED_MODULE_2__/* .ToastDescriptionWithTx */ .Y, {
                                txHash: receipt.transactionHash
                            }));
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsCreateProxyLoading(false);
                        onDone === null || onDone === void 0 ? void 0 : onDone();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }),
        isLoading: isCreateProxyLoading || loading,
        endIcon: isCreateProxyLoading || loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            spin: true,
            color: "currentColor"
        }) : undefined,
        children: isCreateProxyLoading || loading ? t("Confirming...") : t("Enable")
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_5__.memo)(CreateProxyButton));


/***/ }),

/***/ 65563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ YieldBoosterStateContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34291);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4430);






var YieldBoosterStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    boosterState: _hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_3__/* .YieldBoosterState.UNCONNECTED */ .M.UNCONNECTED,
    refreshActivePool: (lodash_noop__WEBPACK_IMPORTED_MODULE_2___default()),
    proxyFarm: {},
    shouldUseProxyFarm: false,
    refreshProxyAddress: (lodash_noop__WEBPACK_IMPORTED_MODULE_2___default()),
    proxyAddress: ""
});
var ProxyFarmContainer = function(param) {
    var children = param.children, farm = param.farm;
    var ref = (0,_hooks_useYieldBoosterState__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        farmPid: farm.pid
    }), boosterState = ref.state, refreshActivePool = ref.refreshActivePool, shouldUseProxyFarm = ref.shouldUseProxyFarm, refreshProxyAddress = ref.refreshProxyAddress, proxyAddress = ref.proxyAddress;
    var proxyFarm = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, farm), {
            userData: farm.userData.proxy
        });
    }, [
        farm
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YieldBoosterStateContext.Provider, {
        value: {
            proxyAddress: proxyAddress,
            boosterState: boosterState,
            refreshActivePool: refreshActivePool,
            refreshProxyAddress: refreshProxyAddress,
            proxyFarm: proxyFarm,
            shouldUseProxyFarm: shouldUseProxyFarm
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ProxyFarmContainer));


/***/ }),

/***/ 16406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBoostMultiplier; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5163);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68390);
/* harmony import */ var config_abi_farmBooster_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74551);
/* harmony import */ var config_abi_masterchef_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84951);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49222);
/* harmony import */ var utils_multicall__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25152);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49857);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7642);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_toNumber__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51523);
/* harmony import */ var _useYieldBoosterState__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4430);













var PRECISION_FACTOR = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_8__/* .FixedNumber.from */ .xs.from("1000000000000") // 1e12
;
function getPublicMultiplier(_) {
    return _getPublicMultiplier.apply(this, arguments);
}
function _getPublicMultiplier() {
    _getPublicMultiplier = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(param) {
        var farmBoosterContract, calls, data, _data, ref, cA, ref1, CA_PRECISION, ref2, BOOST_PRECISION, MAX_BOOST_PRECISION, boostPercent;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    farmBoosterContract = param.farmBoosterContract;
                    calls = [
                        {
                            address: farmBoosterContract.address,
                            name: "cA"
                        },
                        {
                            address: farmBoosterContract.address,
                            name: "CA_PRECISION"
                        },
                        {
                            address: farmBoosterContract.address,
                            name: "BOOST_PRECISION"
                        }
                    ];
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_3__/* .multicallv2 */ .v)({
                            abi: config_abi_farmBooster_json__WEBPACK_IMPORTED_MODULE_1__,
                            calls: calls
                        })
                    ];
                case 1:
                    data = _state.sent();
                    if (!data) return [
                        2,
                        0
                    ];
                    _data = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(data, 3), ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_data[0], 1), cA = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_data[1], 1), CA_PRECISION = ref1[0], ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_data[2], 1), BOOST_PRECISION = ref2[0];
                    MAX_BOOST_PRECISION = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_8__/* .FixedNumber.from */ .xs.from(CA_PRECISION).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_8__/* .FixedNumber.from */ .xs.from(cA)).mulUnsafe(PRECISION_FACTOR).subUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_8__/* .FixedNumber.from */ .xs.from(BOOST_PRECISION));
                    boostPercent = PRECISION_FACTOR.addUnsafe(MAX_BOOST_PRECISION).divUnsafe(PRECISION_FACTOR);
                    return [
                        2,
                        lodash_toNumber__WEBPACK_IMPORTED_MODULE_6___default()(boostPercent.round(3).toString())
                    ];
            }
        });
    });
    return _getPublicMultiplier.apply(this, arguments);
}
function getUserMultiplier(_) {
    return _getUserMultiplier.apply(this, arguments);
}
function _getUserMultiplier() {
    _getUserMultiplier = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(param) {
        var farmBoosterContract, account, pid, calls, data, _data, ref, multiplier, ref1, BOOST_PRECISION;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    farmBoosterContract = param.farmBoosterContract, account = param.account, pid = param.pid;
                    calls = [
                        {
                            address: farmBoosterContract.address,
                            name: "getUserMultiplier",
                            params: [
                                account,
                                pid
                            ]
                        },
                        {
                            address: farmBoosterContract.address,
                            name: "BOOST_PRECISION"
                        }
                    ];
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_3__/* .multicallv2 */ .v)({
                            abi: config_abi_farmBooster_json__WEBPACK_IMPORTED_MODULE_1__,
                            calls: calls
                        })
                    ];
                case 1:
                    data = _state.sent();
                    if (!data) return [
                        2,
                        0
                    ];
                    _data = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(data, 2), ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_data[0], 1), multiplier = ref[0], ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_data[1], 1), BOOST_PRECISION = ref1[0];
                    return [
                        2,
                        lodash_toNumber__WEBPACK_IMPORTED_MODULE_6___default()(PRECISION_FACTOR.addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_8__/* .FixedNumber.from */ .xs.from(multiplier)).subUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_8__/* .FixedNumber.from */ .xs.from(BOOST_PRECISION)).divUnsafe(PRECISION_FACTOR).round(3).toString())
                    ];
            }
        });
    });
    return _getUserMultiplier.apply(this, arguments);
}
function getMultiplierFromMC(_) {
    return _getMultiplierFromMC.apply(this, arguments);
}
function _getMultiplierFromMC() {
    _getMultiplierFromMC = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(param) {
        var pid, proxyAddress, masterChefContract, calls, data, _data, ref, boostMultiplier;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pid = param.pid, proxyAddress = param.proxyAddress, masterChefContract = param.masterChefContract;
                    calls = [
                        {
                            address: masterChefContract.address,
                            name: "getBoostMultiplier",
                            params: [
                                proxyAddress,
                                pid
                            ]
                        }
                    ];
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_3__/* .multicallv2 */ .v)({
                            abi: config_abi_masterchef_json__WEBPACK_IMPORTED_MODULE_2__,
                            calls: calls
                        })
                    ];
                case 1:
                    data = _state.sent();
                    if (!(data === null || data === void 0 ? void 0 : data.length)) return [
                        2,
                        0
                    ];
                    _data = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(data, 1), ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_data[0], 1), boostMultiplier = ref[0];
                    return [
                        2,
                        lodash_toNumber__WEBPACK_IMPORTED_MODULE_6___default()(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_8__/* .FixedNumber.from */ .xs.from(boostMultiplier).divUnsafe(PRECISION_FACTOR).round(3).toString())
                    ];
            }
        });
    });
    return _getMultiplierFromMC.apply(this, arguments);
}
function useBoostMultiplier(param) {
    var pid = param.pid, boosterState = param.boosterState, proxyAddress = param.proxyAddress;
    var farmBoosterContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_0__/* .useBCakeFarmBoosterContract */ .gh)();
    var masterChefContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_0__/* .useMasterchef */ .y8)();
    var ref = (0,wagmi__WEBPACK_IMPORTED_MODULE_12__/* .useAccount */ .mA)(), account = ref.address;
    var shouldGetFromSC = [
        _useYieldBoosterState__WEBPACK_IMPORTED_MODULE_7__/* .YieldBoosterState.DEACTIVE */ .M.DEACTIVE,
        _useYieldBoosterState__WEBPACK_IMPORTED_MODULE_7__/* .YieldBoosterState.ACTIVE */ .M.ACTIVE,
        _useYieldBoosterState__WEBPACK_IMPORTED_MODULE_7__/* .YieldBoosterState.MAX */ .M.MAX
    ].includes(boosterState);
    var should1X = [
        _useYieldBoosterState__WEBPACK_IMPORTED_MODULE_7__/* .YieldBoosterState.LOCKED_END */ .M.LOCKED_END
    ].includes(boosterState);
    var getMultiplier = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            if (shouldGetFromSC) {
                return [
                    2,
                    getMultiplierFromMC({
                        pid: pid,
                        masterChefContract: masterChefContract,
                        proxyAddress: proxyAddress
                    })
                ];
            }
            return [
                2,
                should1X ? getUserMultiplier({
                    farmBoosterContract: farmBoosterContract,
                    pid: pid,
                    account: account
                }) : getPublicMultiplier({
                    farmBoosterContract: farmBoosterContract
                })
            ];
        });
    }), [
        farmBoosterContract,
        masterChefContract,
        should1X,
        shouldGetFromSC,
        pid,
        account,
        proxyAddress
    ]);
    var cacheName = shouldGetFromSC ? "proxy".concat(pid) : should1X ? "user".concat(pid) : "public".concat(pid);
    var data = (0,swr__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)([
        "boostMultiplier",
        cacheName
    ], getMultiplier).data;
    return data || 0;
}


/***/ }),

/***/ 83117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ax": function() { return /* binding */ useGetBoostedMultiplier; },
/* harmony export */   "yK": function() { return /* binding */ useGetCalculatorMultiplier; }
/* harmony export */ });
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7642);
/* harmony import */ var lodash_toNumber__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_toNumber__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var state_pools_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99225);
/* harmony import */ var views_Farms_components_YieldBooster_components_BCakeCalculator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40933);
/* harmony import */ var views_Farms_hooks_useUserLockedCakeStatus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82159);
/* harmony import */ var views_Pools_components_LockedPool_hooks_useAvgLockDuration__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22557);
/* harmony import */ var views_Pools_components_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14457);







var useGetBoostedMultiplier = function(userBalanceInFarm, lpTotalSupply) {
    (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useCakeVaultPublicData */ .uf)();
    (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useCakeVaultUserData */ .Es)();
    var avgLockDurationsInSeconds = (0,views_Pools_components_LockedPool_hooks_useAvgLockDuration__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().avgLockDurationsInSeconds;
    var ref = (0,views_Farms_hooks_useUserLockedCakeStatus__WEBPACK_IMPORTED_MODULE_4__/* .useUserLockedCakeStatus */ .u)(), isLoading = ref.isLoading, lockedAmount = ref.lockedAmount, totalLockedAmount = ref.totalLockedAmount, lockedStart = ref.lockedStart, lockedEnd = ref.lockedEnd;
    var bCakeMultiplier = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var result = (0,views_Farms_components_YieldBooster_components_BCakeCalculator__WEBPACK_IMPORTED_MODULE_3__/* .getBCakeMultiplier */ .K)(userBalanceInFarm, lockedAmount, (0,views_Pools_components_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_6__/* .secondsToDays */ .i8)(lodash_toNumber__WEBPACK_IMPORTED_MODULE_0___default()(lockedEnd) - lodash_toNumber__WEBPACK_IMPORTED_MODULE_0___default()(lockedStart)), totalLockedAmount, lpTotalSupply, avgLockDurationsInSeconds ? (0,views_Pools_components_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_6__/* .secondsToDays */ .i8)(avgLockDurationsInSeconds) : 280);
        return result.toString() === "NaN" || isLoading ? "1.000" : result.toFixed(3);
    }, [
        userBalanceInFarm,
        lpTotalSupply,
        totalLockedAmount,
        avgLockDurationsInSeconds,
        lockedAmount,
        lockedEnd,
        lockedStart,
        isLoading, 
    ]);
    return lodash_toNumber__WEBPACK_IMPORTED_MODULE_0___default()(bCakeMultiplier);
};
var useGetCalculatorMultiplier = function(userBalanceInFarm, lpTotalSupply, lockedAmount, userLockDuration) {
    (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useCakeVaultPublicData */ .uf)();
    (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useCakeVaultUserData */ .Es)();
    var avgLockDurationsInSeconds = (0,views_Pools_components_LockedPool_hooks_useAvgLockDuration__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().avgLockDurationsInSeconds;
    var ref = (0,views_Farms_hooks_useUserLockedCakeStatus__WEBPACK_IMPORTED_MODULE_4__/* .useUserLockedCakeStatus */ .u)(), isLoading = ref.isLoading, totalLockedAmount = ref.totalLockedAmount;
    var bCakeMultiplier = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var result = (0,views_Farms_components_YieldBooster_components_BCakeCalculator__WEBPACK_IMPORTED_MODULE_3__/* .getBCakeMultiplier */ .K)(userBalanceInFarm, lockedAmount, (0,views_Pools_components_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_6__/* .secondsToDays */ .i8)(userLockDuration), totalLockedAmount, lpTotalSupply, avgLockDurationsInSeconds ? (0,views_Pools_components_utils_formatSecondsToWeeks__WEBPACK_IMPORTED_MODULE_6__/* .secondsToDays */ .i8)(avgLockDurationsInSeconds) : 280);
        return result.toString() === "NaN" || isLoading ? "1.000" : result.toFixed(3);
    }, [
        userBalanceInFarm,
        lpTotalSupply,
        totalLockedAmount,
        avgLockDurationsInSeconds,
        lockedAmount,
        isLoading,
        userLockDuration, 
    ]);
    return lodash_toNumber__WEBPACK_IMPORTED_MODULE_0___default()(bCakeMultiplier);
};
var useGetBoostedAPR = function(userBalanceInFarm, lpTotalSupply, apr, lpRewardsApr) {
    var bCakeMultiplier = useGetBoostedMultiplier(userBalanceInFarm, lpTotalSupply);
    return (apr * bCakeMultiplier + lpRewardsApr).toFixed(2);
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGetBoostedAPR);


/***/ }),

/***/ 4430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ YieldBoosterState; },
/* harmony export */   "Z": function() { return /* binding */ useYieldBoosterState; }
/* harmony export */ });
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65342);
/* harmony import */ var state_farms_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8919);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68390);
/* harmony import */ var hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30433);
/* harmony import */ var config_abi_farmBooster_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74551);
/* harmony import */ var _pancakeswap_utils_isUndefinedOrNull__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16844);
/* harmony import */ var views_Farms_hooks_useUserBoosterStatus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92516);
/* harmony import */ var views_Farms_hooks_useBCakeProxyContractAddress__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62704);
/* harmony import */ var views_Farms_hooks_useUserLockedCakeStatus__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82159);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2784);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51523);











var YieldBoosterState;
(function(YieldBoosterState) {
    YieldBoosterState[YieldBoosterState["UNCONNECTED"] = 0] = "UNCONNECTED";
    YieldBoosterState[YieldBoosterState["NO_LOCKED"] = 1] = "NO_LOCKED";
    YieldBoosterState[YieldBoosterState["LOCKED_END"] = 2] = "LOCKED_END";
    YieldBoosterState[YieldBoosterState["NO_PROXY_CREATED"] = 3] = "NO_PROXY_CREATED";
    YieldBoosterState[YieldBoosterState["NO_MIGRATE"] = 4] = "NO_MIGRATE";
    YieldBoosterState[YieldBoosterState["NO_LP"] = 5] = "NO_LP";
    YieldBoosterState[YieldBoosterState["DEACTIVE"] = 6] = "DEACTIVE";
    YieldBoosterState[YieldBoosterState["ACTIVE"] = 7] = "ACTIVE";
    YieldBoosterState[YieldBoosterState["ACTIVE_AND_NO_LP"] = 8] = "ACTIVE_AND_NO_LP";
    YieldBoosterState[YieldBoosterState["MAX"] = 9] = "MAX";
})(YieldBoosterState || (YieldBoosterState = {}));
function useIsPoolActive(pid) {
    var farmBoosterContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useBCakeFarmBoosterContract */ .gh)();
    var ref = (0,wagmi__WEBPACK_IMPORTED_MODULE_9__/* .useAccount */ .mA)(), account = ref.address;
    var ref1 = (0,hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_3__/* .useSWRMulticall */ .d5)(config_abi_farmBooster_json__WEBPACK_IMPORTED_MODULE_4__, [
        {
            address: farmBoosterContract.address,
            name: "isBoostedPool",
            params: [
                account,
                pid
            ]
        }
    ], {
        isPaused: function() {
            return !account;
        }
    }), data = ref1.data, mutate = ref1.mutate;
    return {
        isActivePool: Array.isArray(data) ? data[0][0] : false,
        refreshIsPoolActive: mutate
    };
}
function useYieldBoosterState(yieldBoosterStateArgs) {
    var farmPid = yieldBoosterStateArgs.farmPid;
    var ref = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), account = ref.account, chainId = ref.chainId;
    var ref1 = (0,views_Farms_hooks_useUserBoosterStatus__WEBPACK_IMPORTED_MODULE_5__/* .useUserBoosterStatus */ .p)(account), remainingCounts = ref1.remainingCounts, refreshActivePools = ref1.refreshActivePools;
    var ref2 = (0,views_Farms_hooks_useUserLockedCakeStatus__WEBPACK_IMPORTED_MODULE_7__/* .useUserLockedCakeStatus */ .u)(), locked = ref2.locked, lockedEnd = ref2.lockedEnd;
    var ref3 = (0,state_farms_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useFarmUser */ .Dx)(farmPid), stakedBalance = ref3.stakedBalance, proxy = ref3.proxy;
    var ref4 = useIsPoolActive(farmPid), isActivePool = ref4.isActivePool, refreshIsPoolActive = ref4.refreshIsPoolActive;
    var ref5 = (0,views_Farms_hooks_useBCakeProxyContractAddress__WEBPACK_IMPORTED_MODULE_6__/* .useBCakeProxyContractAddress */ .A)(account, chainId), proxyCreated = ref5.proxyCreated, refreshProxyAddress = ref5.refreshProxyAddress, proxyAddress = ref5.proxyAddress;
    var refreshActivePool = (0,react__WEBPACK_IMPORTED_MODULE_8__.useCallback)(function() {
        refreshActivePools();
        refreshIsPoolActive();
    }, [
        refreshActivePools,
        refreshIsPoolActive
    ]);
    var state = null;
    if (!account || (0,_pancakeswap_utils_isUndefinedOrNull__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(locked)) {
        state = YieldBoosterState.UNCONNECTED;
    } else if (!locked && stakedBalance.eq(0)) {
        // NOTE: depend on useCakeVaultUserData in Farm Component to check state
        state = YieldBoosterState.NO_LOCKED;
    } else if (!proxyCreated) {
        state = YieldBoosterState.NO_PROXY_CREATED;
    } else if (stakedBalance.gt(0)) {
        state = YieldBoosterState.NO_MIGRATE;
    } else if (lockedEnd === "0" || new Date() > new Date(parseInt(lockedEnd) * 1000)) {
        // NOTE: duplicate logic in BCakeBoosterCard
        state = YieldBoosterState.LOCKED_END;
    } else if (!isActivePool && (proxy === null || proxy === void 0 ? void 0 : proxy.stakedBalance.eq(0))) {
        state = YieldBoosterState.NO_LP;
    } else if (!isActivePool && remainingCounts === 0) {
        state = YieldBoosterState.MAX;
    } else if (isActivePool && (proxy === null || proxy === void 0 ? void 0 : proxy.stakedBalance.eq(0))) {
        state = YieldBoosterState.ACTIVE_AND_NO_LP;
    } else if (isActivePool) {
        state = YieldBoosterState.ACTIVE;
    } else {
        state = YieldBoosterState.DEACTIVE;
    }
    return {
        state: state,
        shouldUseProxyFarm: proxyCreated && stakedBalance.eq(0),
        refreshActivePool: refreshActivePool,
        refreshProxyAddress: refreshProxyAddress,
        proxyAddress: proxyAddress
    };
}


/***/ }),

/***/ 6774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getDisplayApr; }
/* harmony export */ });
var getDisplayApr = function(monkRewardsApr, lpRewardsApr) {
    // console.log(monkRewardsApr, lpRewardsApr)
    if (monkRewardsApr && lpRewardsApr) {
        return (monkRewardsApr + lpRewardsApr).toLocaleString("en-US", {
            maximumFractionDigits: 2
        });
    }
    if (monkRewardsApr) {
        return monkRewardsApr.toLocaleString("en-US", {
            maximumFractionDigits: 2
        });
    }
    return null;
};


/***/ }),

/***/ 34039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useApproveBoostProxyFarm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90711);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70627);
/* harmony import */ var hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23111);
/* harmony import */ var utils_verifyBscNetwork__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30375);







var useApproveFarm = function(lpContract, chainId) {
    var isBscNetwork = (0,utils_verifyBscNetwork__WEBPACK_IMPORTED_MODULE_3__/* .verifyBscNetwork */ .H)(chainId);
    var contractAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMasterChefAddress */ .Oc)(chainId);
    // const contractAddress = isBscNetwork ? getMasterChefAddress(chainId) : getNonBscVaultAddress(chainId)
    var callWithGasPrice = (0,hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_2__/* .useCallWithGasPrice */ .d)().callWithGasPrice;
    var handleApprove = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            console.log(isBscNetwork, contractAddress, chainId);
            return [
                2,
                callWithGasPrice(lpContract, "approve", [
                    contractAddress,
                    _ethersproject_constants__WEBPACK_IMPORTED_MODULE_6__/* .MaxUint256 */ .Bz
                ])
            ];
        });
    }), [
        lpContract,
        contractAddress,
        callWithGasPrice
    ]);
    return {
        onApprove: handleApprove
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useApproveFarm);
var useApproveBoostProxyFarm = function(lpContract, proxyAddress) {
    var callWithGasPrice = (0,hooks_useCallWithGasPrice__WEBPACK_IMPORTED_MODULE_2__/* .useCallWithGasPrice */ .d)().callWithGasPrice;
    var handleApprove = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            return [
                2,
                proxyAddress && callWithGasPrice(lpContract, "approve", [
                    proxyAddress,
                    _ethersproject_constants__WEBPACK_IMPORTED_MODULE_6__/* .MaxUint256 */ .Bz
                ])
            ];
        });
    }), [
        lpContract,
        proxyAddress,
        callWithGasPrice
    ]);
    return {
        onApprove: handleApprove
    };
};


/***/ }),

/***/ 50256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useOraclePrice; }
/* harmony export */ });
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90902);
/* harmony import */ var utils_contractHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30896);
/* harmony import */ var hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30433);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90711);




var getOracleAddress = function(chainId) {
    switch(chainId){
        case _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.ETHEREUM */ .a_.ETHEREUM:
        case _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.GOERLI */ .a_.GOERLI:
            return "0x63D407F32Aa72E63C7209ce1c2F5dA40b3AaE726" // ETH/BNB pair
            ;
        default:
            return "";
    }
};
var useOraclePrice = function(chainId) {
    var tokenAddress = getOracleAddress(chainId);
    var chainlinkOracleContract = (0,utils_contractHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getChainlinkOracleContract */ .Qr)(tokenAddress, null, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC);
    // Can refactor to subscription later
    var ref = (0,hooks_useSWRContract__WEBPACK_IMPORTED_MODULE_2__/* .useSWRContract */ .Av)([
        chainlinkOracleContract,
        "latestAnswer"
    ], {
        refreshWhenHidden: true,
        refreshWhenOffline: true,
        fallbackData: _ethersproject_constants__WEBPACK_IMPORTED_MODULE_3__/* .Zero */ ._Y
    }), price = ref.data;
    return price.toString();
};


/***/ }),

/***/ 82476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65342);
/* harmony import */ var utils_calls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72179);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68390);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72135);
/* harmony import */ var views_Farms_hooks_useFetchOraclePrice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50256);








var useStakeFarms = function(pid, vaultPid) {
    var ref = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), account = ref.account, chainId = ref.chainId;
    var gasPrice = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useGasPrice */ .Fh)();
    var oraclePrice = (0,views_Farms_hooks_useFetchOraclePrice__WEBPACK_IMPORTED_MODULE_5__/* .useOraclePrice */ .L)(chainId);
    var masterChefContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_3__/* .useMasterchef */ .y8)();
    var nonBscVaultContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_3__/* .useNonBscVault */ .LZ)();
    var handleStake = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(amount) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                return [
                    2,
                    (0,utils_calls__WEBPACK_IMPORTED_MODULE_2__/* .stakeFarm */ .AQ)(masterChefContract, pid, amount, gasPrice)
                ];
            });
        });
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        masterChefContract,
        pid,
        gasPrice
    ]);
    var handleStakeNonBsc = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(amount) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                return [
                    2,
                    (0,utils_calls__WEBPACK_IMPORTED_MODULE_2__/* .nonBscStakeFarm */ .qq)(nonBscVaultContract, vaultPid, amount, gasPrice, account, oraclePrice, chainId)
                ];
            });
        });
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        nonBscVaultContract,
        vaultPid,
        gasPrice,
        account,
        oraclePrice,
        chainId
    ]);
    return {
        onStake: vaultPid ? handleStakeNonBsc : handleStake
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useStakeFarms);


/***/ }),

/***/ 85441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65342);
/* harmony import */ var utils_calls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72179);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68390);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72135);
/* harmony import */ var views_Farms_hooks_useFetchOraclePrice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50256);








var useUnstakeFarms = function(pid, vaultPid) {
    var ref = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), account = ref.account, chainId = ref.chainId;
    var gasPrice = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useGasPrice */ .Fh)();
    var oraclePrice = (0,views_Farms_hooks_useFetchOraclePrice__WEBPACK_IMPORTED_MODULE_5__/* .useOraclePrice */ .L)(chainId);
    var masterChefContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_3__/* .useMasterchef */ .y8)();
    var nonBscVaultContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_3__/* .useNonBscVault */ .LZ)();
    var handleUnstake = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(amount) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                return [
                    2,
                    (0,utils_calls__WEBPACK_IMPORTED_MODULE_2__/* .unstakeFarm */ .dU)(masterChefContract, pid, amount, gasPrice)
                ];
            });
        });
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        masterChefContract,
        pid,
        gasPrice
    ]);
    var handleUnstakeNonBsc = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(amount) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                return [
                    2,
                    (0,utils_calls__WEBPACK_IMPORTED_MODULE_2__/* .nonBscUnstakeFarm */ .zv)(nonBscVaultContract, vaultPid, amount, gasPrice, account, oraclePrice, chainId)
                ];
            });
        });
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        nonBscVaultContract,
        vaultPid,
        gasPrice,
        account,
        oraclePrice,
        chainId
    ]);
    return {
        onUnstake: vaultPid ? handleUnstakeNonBsc : handleUnstake
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useUnstakeFarms);


/***/ }),

/***/ 92516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useUserBoosterStatus; }
/* harmony export */ });
/* harmony import */ var config_constants_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6429);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68390);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49857);
/* harmony import */ var swr_immutable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2303);




var useUserBoosterStatus = function(account) {
    var farmBoosterContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_1__/* .useBCakeFarmBoosterContract */ .gh)();
    var ref = (0,swr_immutable__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("maxBoostFarm", function() {
        return farmBoosterContract.MAX_BOOST_POOL();
    }), MAX_BOOST_POOL = ref.data, maxBoostStatus = ref.status;
    var ref1 = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(account && [
        "activatedBoostFarm",
        [
            account
        ]
    ], function() {
        return farmBoosterContract.activedPools(account);
    }), activatedPools = ref1.data, status = ref1.status, mutate = ref1.mutate;
    var ref2, ref3, ref4, ref5;
    return {
        maxBoostCounts: (ref2 = MAX_BOOST_POOL === null || MAX_BOOST_POOL === void 0 ? void 0 : MAX_BOOST_POOL.toNumber()) !== null && ref2 !== void 0 ? ref2 : 0,
        activatedPoolsCounts: (ref3 = activatedPools === null || activatedPools === void 0 ? void 0 : activatedPools.length) !== null && ref3 !== void 0 ? ref3 : 0,
        remainingCounts: ((ref4 = MAX_BOOST_POOL === null || MAX_BOOST_POOL === void 0 ? void 0 : MAX_BOOST_POOL.toNumber()) !== null && ref4 !== void 0 ? ref4 : 0) - ((ref5 = activatedPools === null || activatedPools === void 0 ? void 0 : activatedPools.length) !== null && ref5 !== void 0 ? ref5 : 0),
        isLoading: maxBoostStatus !== config_constants_types__WEBPACK_IMPORTED_MODULE_0__/* .FetchStatus.Fetched */ .iF.Fetched || status !== config_constants_types__WEBPACK_IMPORTED_MODULE_0__/* .FetchStatus.Fetched */ .iF.Fetched,
        refreshActivePools: mutate
    };
};


/***/ }),

/***/ 82159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useUserLockedCakeStatus; }
/* harmony export */ });
/* harmony import */ var state_pools_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99225);
/* harmony import */ var state_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93638);


var useUserLockedCakeStatus = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var vaultPool = (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useVaultPoolByKey */ .eB)(state_types__WEBPACK_IMPORTED_MODULE_1__/* .VaultKey.CakeVault */ .om.CakeVault);
    return {
        totalCakeInVault: vaultPool === null || vaultPool === void 0 ? void 0 : vaultPool.totalCakeInVault,
        totalLockedAmount: vaultPool === null || vaultPool === void 0 ? void 0 : vaultPool.totalLockedAmount,
        isLoading: vaultPool === null || vaultPool === void 0 ? void 0 : (ref = vaultPool.userData) === null || ref === void 0 ? void 0 : ref.isLoading,
        locked: Boolean(vaultPool === null || vaultPool === void 0 ? void 0 : (ref1 = vaultPool.userData) === null || ref1 === void 0 ? void 0 : ref1.locked),
        lockedEnd: vaultPool === null || vaultPool === void 0 ? void 0 : (ref2 = vaultPool.userData) === null || ref2 === void 0 ? void 0 : ref2.lockEndTime,
        lockedAmount: vaultPool === null || vaultPool === void 0 ? void 0 : (ref3 = vaultPool.userData) === null || ref3 === void 0 ? void 0 : ref3.lockedAmount,
        lockBalance: vaultPool === null || vaultPool === void 0 ? void 0 : (ref4 = vaultPool.userData) === null || ref4 === void 0 ? void 0 : ref4.balance,
        lockedStart: vaultPool === null || vaultPool === void 0 ? void 0 : (ref5 = vaultPool.userData) === null || ref5 === void 0 ? void 0 : ref5.lockStartTime
    };
};


/***/ }),

/***/ 74551:
/***/ (function(module) {

module.exports = JSON.parse('[{"inputs":[{"internalType":"address","name":"_cake","type":"address"},{"internalType":"address","name":"_cakePool","type":"address"},{"internalType":"address","name":"_v2","type":"address"},{"internalType":"uint256","name":"_max","type":"uint256"},{"internalType":"uint256","name":"_cA","type":"uint256"},{"internalType":"uint256","name":"_cB","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"}],"name":"ActiveFarmPool","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"}],"name":"DeactiveFarmPool","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"}],"name":"Refresh","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"factory","type":"address"}],"name":"UpdateBoostFactory","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"},{"indexed":false,"internalType":"bool","name":"status","type":"bool"}],"name":"UpdateBoostFarms","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"proxy","type":"address"}],"name":"UpdateBoostProxy","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"oldCA","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newCA","type":"uint256"}],"name":"UpdateCA","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"oldCB","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newCB","type":"uint256"}],"name":"UpdateCB","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"lockedAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lockedDuration","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"totalLockedAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"maxLockDuration","type":"uint256"}],"name":"UpdateCakePool","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"factory","type":"uint256"}],"name":"UpdateMaxBoostPool","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"pid","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"oldMultiplier","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newMultiplier","type":"uint256"}],"name":"UpdatePoolBoostMultiplier","type":"event"},{"inputs":[],"name":"BOOSTER_FACTORY","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"BOOST_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"BOOST_RATIO_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"BOOST_WEIGHT_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"CAKE","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"CAKE_POOL","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"CA_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MASTER_CHEF","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_BOOST_POOL","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_BOOST_PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_CA","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_CB","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MIN_CA","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MIN_CB","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"activate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"activedPools","outputs":[{"internalType":"uint256[]","name":"pools","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"avgLockDuration","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cA","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cB","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"deactive","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"getUserMultiplier","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"isBoostedPool","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_lockedAmount","type":"uint256"},{"internalType":"uint256","name":"_lockedDuration","type":"uint256"},{"internalType":"uint256","name":"_totalLockedAmount","type":"uint256"},{"internalType":"uint256","name":"_maxLockDuration","type":"uint256"}],"name":"onCakePoolUpdate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"proxyContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"refresh","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_factory","type":"address"}],"name":"setBoostFactory","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"},{"internalType":"bool","name":"_status","type":"bool"}],"name":"setBoosterFarms","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_cA","type":"uint256"}],"name":"setCA","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_cB","type":"uint256"}],"name":"setCB","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_max","type":"uint256"}],"name":"setMaxBoostPool","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"address","name":"_proxy","type":"address"}],"name":"setProxy","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"updatePoolBoostMultiplier","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userInfo","outputs":[{"internalType":"uint256","name":"size","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"whiteList","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"}]');

/***/ })

}]);